export default __webpack_public_path__ + "static/media/Giuliaformodels.18761236.mp4";